import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { AuthenticationService, Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult, RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { DataSet } from '@app/shared/kendo/data-set';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { CampaignService } from '@app/campaign/campaign.service';
import { Router } from '@angular/router';
import { Campaign } from '@app/campaign/campaign.model';

const log = new Logger('CampaignListComponent');

@Component({
  selector: 'campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.scss'],
  // Вътрешните също трябва да имат changeDetection...
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignListComponent extends KendoGridComponent implements OnInit {
  requestsResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  eventGroupId: number;
  AuthenticationService = AuthenticationService;

  UserRoleType = UserRoleType;
  LaravelModelsEnum = LaravelModelsEnum;

  loader = false;

  constructor(
    protected kendoGridService: KendoGridService,
    public accessService: AccessService,
    private campaignService: CampaignService,
    private router: Router
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    log.debug('CampaignListComponent init');
    this.state = new DataSet().addSort('created_at', 'desc');
    const storageFilter = CustomKendoFilter.getStateFromStorage('CampaignListComponent');
    if (storageFilter) {
      this.state = storageFilter;
    }
    this.loadData(this.state);
  }

  clearFilters() {
    this.router.navigate(['/campaign-list']);
    this.apiQuery = new ApiQuery();
    this.loadData();
  }

  loadData(state: DataStateChangeEvent = null) {
    log.debug('loadData', state);
    this.loader = true;
    this.state = state;
    this.apiQuery.setDataSetFilters(state).addIncludes('event', 'event.event_group', 'sales', 'creator', 'template');

    this.campaignService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.requestsResponse = response;
      this.data = response.getGridData();
      this.loader = false;
    });

    CustomKendoFilter.pushStateInStorage('CampaignListComponent', this.state);
  }

  delete(campaign: Campaign): void {
    this.campaignService.destroy(campaign.id).subscribe(() => {
      this.loadData(this.state);
    });
  }
}
